import * as ActionTypes from './types';
import * as API from '../network/api';
import { HHAxiosRequest } from '../network';
import { handleResponseCode } from '.';
import { hlog } from '../common/util';

export const fetchPublicPostings = (pageIndex, objCountPerPage, sortBy) => async (
  dispatch
) => new Promise(async (resolve, reject) => {
  try {
    const requestBody = { pageIndex, objCountPerPage, sortBy };
    const res = await HHAxiosRequest(API.FETCH_PUBLIC_POSTINGS, requestBody);
    if (res && res.data) {
      const { code } = res.data;
      handleResponseCode(code);
      if (code === 200) {
        dispatch({
          type: ActionTypes.FETCH_PUBLIC_POSTINGS,
          payload: res.data.response.publicPostings
        });
        resolve();
      }
    }
  } catch (err) {
    hlog(err);
    reject(err);
  }
});




// WEBPACK FOOTER //
// ./src/components/actions/publicPostings.js